module.exports = __webpack_public_path__ + "img/nosotros_home.12c39729.png";